import { useState, useEffect } from 'react'

import { isObjectEmpty } from 'helpers/object'

export default function useIsTrackEnabled(track) {
    const [isEnabled, setIsEnabled] = useState(track ? track.isEnabled : false)
    useEffect(() => {
        setIsEnabled(track ? track.isEnabled : false)
        if (isObjectEmpty(track)) return
        const setEnabled = () => setIsEnabled(true)
        const setDisabled = () => setIsEnabled(false)
        track && track.on('enabled', setEnabled)
        track && track.on('disabled', setDisabled)
        return () => {
            track.off('enabled', setEnabled)
            track.off('disabled', setDisabled)
        }
    }, [track])
    return isEnabled
}
